
import React from 'react';
import moment from 'moment';

export default function PDFTemplateCampaignAgreement({ accountName, smsOptInAt, minMonthlyCharges }) {

  return (
            <div
              className="App"
              style={{
                fontFamily: "Arial, sans-serif",
                padding: "40px",
                maxWidth: "800px",
                margin: "0 auto",
              }}
              >
              <div id="content">
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                  <strong>{accountName}</strong> activated the SMS Campaign module
                  in their Check This Out account on <strong>{moment(smsOptInAt*1000).format('MMMM D, YYYY hh:mm:ss A')} </strong>
                  and agreed to the following pricing, terms, and conditions.
                </p>
                <h2
                  style={{
                    marginTop: "30px",
                    fontSize: "20px",
                  }}
                >
                Text recipients
                </h2>
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>
                  Unless you select Tags when creating a campaign, all of your contacts
                  will receive text campaigns. Opt-out information is automatically
                  attached to each campaign.
                </p>
                <h2
                  style={{
                    marginTop: "30px",
                    fontSize: "20px",
                  }}
                >
                  Pricing
                </h2>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginTop: "15px",
                  }}
                  border="1"
                  cellPadding="10"
                  cellSpacing="0"
                >
                  <thead>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #000",
                          padding: "12px",
                          backgroundColor: "#f2f2f2",
                          textAlign: "left",
                          fontSize: "16px",
                        }}
                      >
                        Credits per month
                      </th>
                      <th
                        style={{
                          border: "1px solid #000",
                          padding: "12px",
                          backgroundColor: "#f2f2f2",
                          textAlign: "left",
                          fontSize: "16px",
                        }}
                      >
                        Cost per credit
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        Up to 3,000
                      </td>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        $0.036
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        3,001-7,500
                      </td>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        $0.024
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        7,501-25,000
                      </td>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        $0.018
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        25,001-50,000
                      </td>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        $0.015
                      </td>
                    </tr>
                    <tr>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        At least 50,001
                      </td>
                      <td style={{ border: "1px solid #000", padding: "12px", fontSize: "16px" }}>
                        $0.014
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p style={{ fontSize: "16px", marginTop: "20px" }}>
                  <strong>SMS Campaigns:</strong> 1 credit per 160 characters
                  <br /><br/>
                  <strong>MMS Campaigns:</strong> 3 credits
                </p>
                <br/>
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>Your credit card will automatically be charged after you send an SMS/MMS campaign and charges will appear on your monthly Check This Out invoice.</p>
                {minMonthlyCharges > 0 
                   ? 
                   <p style={{ fontSize: "16px", lineHeight: "1.5" }}>{accountName} will be charged a minimum monthly fee of ${minMonthlyCharges} that will be credited towards campaign fees and word-of-mouth engine fees incurred each 30 day period.</p> 
                  : ""
                }
                <h2
                  style={{
                    marginTop: "30px",
                    fontSize: "20px",
                  }}
                >
                MMS Campaigns
                </h2>
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>Please allow 48 hours from account activation for Check This Out to enable MMS on your campaign's phone number.</p>
                  
                <h2
                  style={{
                    marginTop: "30px",
                    fontSize: "20px",
                  }}
                >
                Terms and conditions
                </h2>
                <p style={{ fontSize: "16px", lineHeight: "1.5" }}>By clicking on the Activate SMS Campaigns button you agree to the pricing provided above and verify that you have received express written consent to message the contacts in your Check This Out account.</p>
                <br/> <p style={{ fontSize: "16px", lineHeight: "1.5" }}>All other Check This Out Terms of Use and Privacy Policy is available at www.checkthisout.io.</p>
              </div> 
            </div>

  );
}
